export const parallel = async (...args: any[]) => {
    return await Promise.all(args)
}

export const parallelArr = async (args: any[]) => {
    return await Promise.all(args)
}

export const sleep = async (ms: number) => {
    return new Promise(r => setTimeout(r, ms))
}

export const tryAsyncFunc = async (func: Promise<any>) => {
    let result = null
    let error = null
    try {
        result = await func
    } catch (e) {
        error = e

        //this is a JS error, log it...
        if (e instanceof Error) {
            console.error(e)
        }

    }

    if (typeof result === 'undefined' && !error) {
        error = new Error('No return value of func')
        console.error(error)
    }

    return [result, error] as [any, any]
}
